import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { formatMoney, getInlineLoader, callApi } from "../Helpers";
import { MdAdd, MdSearch, MdRefresh } from "react-icons/md";
import OneMotorcycle from "../ones/OneMotorcycle";

export default function View(props) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [category, setCategory] = useState("all"); // 'all', 'published', 'unpublished', 'resale'
  const [filter, setFilter] = useState("");
  const [recsList, setRecsList] = useState(null);
  
  // Data States
  const [resaleRecs, setResaleRecs] = useState([]);

  async function init() {
    setReady(false);
    await Promise.all([appContext.getAllMotorcycles(), fetchResale()]);
    setReady(true);
  }

  async function fetchResale() {
    const res = await callApi("get-resale-motorcycles", {});
    if (res.status === 1) setResaleRecs(res.data || []);
  }

  function processRecs() {
    let _list = [];
    
    if (category === "resale") {
      _list = resaleRecs;
    } else {
      _list = appContext.allMotorcycles || [];
      if (category === "published") _list = _list.filter(i => i.status === "published");
      if (category === "unpublished") _list = _list.filter(i => i.status === "unpublished");
    }

    if (filter && filter.trim().length > 0) {
      const search = filter.toLowerCase();
      setRecsList(_list.filter(item => 
        (item.model || item.motorcycleModel || "").toLowerCase().includes(search) ||
        (item.regNumber || "").toLowerCase().includes(search)
      ));
    } else {
      setRecsList(_list);
    }
  }

  useEffect(() => { init(); }, []);
  useEffect(() => { processRecs(); }, [filter, category, appContext.allMotorcycles, resaleRecs]);

  if (!ready) return <div className="container mSupportLoading">{getInlineLoader()}</div>;

  return (
    <div className="container">
      <div className="app-page">
        <div className="app-page-hero app-page-hero-split">
          <div>
            <h6 className="main-section-title">Motorcycles</h6>
            <p className="app-page-subtitle">Manage your stock, including new models and returned resale units.</p>
          </div>
          <button className="btn btn-primary btn-rounded app-cta-btn" onClick={() => appContext.navTo({ item: "view", subItem: "create-motorcycle" })}>
            <MdAdd size={18} /> Add Motorcycle
          </button>
        </div>

        <div className="list-shell">
          <div className="list-toolbar">
            <div className="modern-search">
              <MdSearch size={20} />
              <input className="form-control" onChange={(e) => setFilter(e.target.value)} placeholder="Search by model or reg number..." />
            </div>

            <select className="form-control modern-filter" value={category} onChange={(e) => setCategory(e.target.value)}>
              <option value="all">All Inventory</option>
              <option value="available">Available</option>
              <option value="resale">Resale Stock ({resaleRecs.length})</option>
            </select>
          </div>

          <div className="entity-list">
            {recsList?.length > 0 ? (
              recsList.map((item, i) => (
                <OneMotorcycle 
                  key={i} 
                  isResale={category === "resale"} 
                  data={{
                    ...item,
                    // Normalize the ID so OneMotorcycle always gets a 'uuid'
                    uuid: item.resaleUuid || item.uuid,
                    model: item.motorcycleModel || item.model,
                    status: item.resaleStatus || item.status || "available",
                    price: item.price || 0 
                  }} 
                />
              ))
            ) : (
              <div className="empty-state-lite">No {category} records were found.</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}